var DevicesPageController = (function () {
    function DevicesPageController($scope, routes, lastViewedService, compareChannel) {
        var _this = this;
        this.$scope = $scope;
        this.routes = routes;
        this.lastViewedService = lastViewedService;
        this.compareChannel = compareChannel;
        this.$scope.onDevicesSelected = function (devices) {
            if (!Array.isArray(devices) || devices.length === 0) {
                return;
            }
            _this.lastViewedService.addLastViewed(devices);
            _this.routes.setGallery(devices.map(function (d) { return d.searchKey; }));
            _this.compareChannel.reset();
        };
    }
    DevicesPageController.$inject = ['$scope', 'routes', 'lastViewedService', 'compareChannel'];
    return DevicesPageController;
}());
export { DevicesPageController };
